import { CSSProperties } from 'styled-components';

export type FlexProps = {
  alignItems?: CSSProperties['alignItems'];
  alignContent?: CSSProperties['alignContent'];
  justifyItems?: CSSProperties['justifyItems'];
  justifyContent?: CSSProperties['justifyContent'];
  flexWrap?: CSSProperties['flexWrap'];
  flexDirection?: CSSProperties['flexDirection'];
  flex?: CSSProperties['flex'];
  flexGrow?: CSSProperties['flexGrow'];
  flexShrink?: CSSProperties['flexShrink'];
  flexBasis?: CSSProperties['flexBasis'];
  justifySelf?: CSSProperties['justifySelf'];
  alignSelf?: CSSProperties['alignSelf'];
  order?: CSSProperties['order'];
};

export const flex = (props: FlexProps) => ({
  alignItems: props.alignItems || 'center',
  alignContent: props.alignContent || 'flex-start',
  justifyItems: props.justifyItems,
  justifyContent: props.justifyContent,
  flexWrap: props.flexWrap,
  flexDirection: props.flexDirection,
  flex: props.flex,
  flexGrow: props.flexGrow,
  flexShrink: props.flexShrink,
  flexBasis: props.flexBasis,
  justifySelf: props.justifySelf,
  alignSelf: props.alignSelf,
  order: props.order,
});
